import type { ReactNode } from "react";
import { RebuildAvatar } from "../RebuildAvatar";

interface UserProps {
  photo?: string;
  icon?: ReactNode;
  name?: string;
}

function getInitials(name?: string): string {
  if (!name) return "U";
  const [firstName, lastName] = name.split(" ");
  return `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
}

const User = ({ name, photo, icon }: UserProps) => {
  const isUnassigned = !name || name === "Assignee";
  const showIcon = icon && !photo && isUnassigned;

  return (
    <div className="flex flex-row items-center space-x-2">
      {showIcon ? icon : <RebuildAvatar photo={photo ?? ""} initials={getInitials(name)} />}
      <p className={isUnassigned ? "text-muted-foreground" : ""}>{name ?? "Unassigned"}</p>
    </div>
  );
};

export default User;
